"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanCodeSendPointsRequest = void 0;
var ScanCodeSendPointsRequest = /** @class */ (function () {
    function ScanCodeSendPointsRequest() {
    }
    return ScanCodeSendPointsRequest;
}());
exports.ScanCodeSendPointsRequest = ScanCodeSendPointsRequest;
;
//# sourceMappingURL=scanCodeSendPoints.request.js.map